export default __webpack_public_path__ + "static/media/loaderblue.ed625649.svg";